import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { paymentStatusService } from '../services/PaymentStatusService';
import { paymentSessionService } from '../services/paymentSessionService';

const StatusHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    const handleStatus = async () => {
      const status = searchParams.get('status')?.toLowerCase();
      const token = searchParams.get('token');

      if (!token) {
        console.warn('No token provided');
        navigate('/');
        return;
      }

      console.log('Handling payment status:', { status, token });

      try {
        const normalizedStatus = (status || '').toLowerCase();
        const canTrustUrlStatus =
          normalizedStatus === 'cancel' ||
          normalizedStatus === 'canceled' ||
          normalizedStatus === 'fail' ||
          normalizedStatus === 'failed' ||
          normalizedStatus === 'expired';

        // Never trust `status=paid` directly from query string.
        const finalStatus = canTrustUrlStatus
          ? await paymentStatusService.updateStatus(token, normalizedStatus)
          : await paymentStatusService.checkInitialStatus(token);

        console.log('Final status:', finalStatus);

        switch (finalStatus.toLowerCase()) {
          case 'paid':
          case 'completed':
            navigate(`/merci?token=${token}`);
            break;
          case 'cancel':
          case 'canceled':
          case 'fail':
          case 'failed':
            (async () => {
              const endpoints = ['/api/checkout/status', '/checkoutStatus.php'];

              for (const endpoint of endpoints) {
                try {
                  const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      token,
                      status: finalStatus,
                    }),
                  });

                  if (response.ok) {
                    return;
                  }
                } catch {
                  // Try next endpoint.
                }
              }
            })().catch((requestError) => {
              console.error('Error persisting checkout failure status:', requestError);
            });
            paymentSessionService.clearSession(token);
            navigate('/');
            break;
          case 'pending':
          default:
            navigate(`/attente?token=${token}`);
            break;
        }
      } catch (error) {
        console.error('Error handling payment status:', error);
        navigate('/');
      }
    };

    handleStatus();
  }, [searchParams, navigate]);

  return null;
};

export default StatusHandler;
